<template>
    <div @click="$emit('CloseLeave')" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-20 backdrop-blur-[2px]">
    </div>
    <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
        <div class="flex flex-col justify-center  z-40 bg-white w-[1000px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
            <div v-if="loading" class="absolute bg-[#00000042] w-full h-full flex justify-center items-center z-0" >
                <span class="loader z-50"></span>
            </div>
            <div class="pafcpic_header bg-[#016B00] py-3 px-6 rounded-t-sm">
                <p class="text-[#ffffff] text-md font-bold ">REFERENCE NO.: {{ Data.leave_key }}</p>
            </div>
            <div class="pafcpic_body py-6 px-6">
                <div class="font-semibold text-[#016B00] text-center mb-6">
                    {{ Data.employee_name }}
                </div>
                <div class="grid grid-cols-4 gap-4 text-sm w-[100%]">
                    <p class="col-span-1 font-semibold text-[#929492]">Total Duration:</p>
                    <div class="col-span-3 font-semibold text-[#016B00]">
                        {{ Data.duration + " "}}
                        <span v-if="Data.duration > 1">DAY(S)</span>
                        <span v-else>DAY</span>
                    </div>
                    <p class="col-span-1 font-semibold text-[#929492]">Reason:</p>
                    <div class="col-span-3 font-semibold text-[#016B00]">
                        {{ Data.reason }}
                    </div>
                    <div class="col-span-4 flex flex-col gap-1 w-full">
                        <table class="w-full ">
                            <tr class="bg-[#016B00] w-full text-white">
                                <th>FROM</th>
                                <th>TO</th>
                                <th>CATEGORY</th>
                                <th>TIME(UNDERTIME)</th>
                                <th>DURATION</th>
                            </tr>
                            <tr v-for="(data,index) in info" :key="index">
                                <td>{{ data.from_date}}</td>
                                <td>{{ data.to_date  }}</td>
                                <td>{{ data.category  }}</td>
                                <td v-if="!data.undertime">N/A</td>
                                <td v-else>{{ data.undertime  }}</td>
                                <td v-if="data.duration > 1">{{ data.duration + " " }}   DAY(S)</td>
                                <td v-else>{{ data.duration  }}   DAY</td>
                            </tr>
                        </table>
                        <div class="mt-5 py-5 border-[#b6b5b5] border-t border-b px-2">
                            <div class="flex gap-5">
                                <div class="w-full flex flex-col gap-2">
                                    <label class="text-sm text-[#6A6A6A] font-semibold">Recommended by:</label>
                                    <div v-if="recommendation == null">
                                        <p class="text-sm text-[#a5a5a5]">NO SIGNATORY FOUND</p>
                                    </div>
                                    <div v-else v-for="(recon,index) in recommendation" :key="index" class="">
                                        <p class="text-md font-semibold  " :class="{'text-[#016B00]': recon.status === 'A','text-[#792424]': recon.status == 'D','text-[#b9b9b9]': !recon.status}">{{recon.employee_name}}</p>
                                        <label class="text-sm text-[#6A6A6A]">Immediate Superior</label>
                                        <div v-if="recon.status == 'D'">
                                            <label class="text-xs font-semibold text-[#6A6A6A]">Remarks:</label>
                                            <p class="text-sm font-semibold text-[#792424]"> {{recon.remarks}}</p>
                                          </div>
                                    </div>
                                </div>
                                <div class=" w-full flex flex-col gap-3">
                                    <label class="text-sm text-[#6A6A6A] font-semibold">Approved by:</label>
                                    <div v-if="approval == null">
                                        <p class="text-sm text-[#a5a5a5]">NO SIGNATORY FOUND</p>
                                    </div>
                                    <div v-else v-for="(approval,index) in approval" :key="index" class="">
                                        <div v-if="approval != null">
                                            <div class="flex relative w-auto">
                                                <p class="text-md font-semibold " :class="{'text-[#016B00]': approval.status == 'A','text-[#792424]': approval.status == 'D','text-[#b9b9b9]': !approval.status}">{{approval.employee_name}}</p>
                                                <!-- <img v-if="approval.status == 'A'" src="../../assets/signature.png" class="w-[80px] absolute   left-10 right-0"> -->
                                            </div>
                                            <label class="text-sm text-[#6A6A6A]">Division / Office Executive</label>
                                            <div v-if="approval.status == 'D'">
                                                <label class="text-xs font-semibold text-[#6A6A6A]">Remarks:</label>
                                                <p class="text-sm font-semibold text-[#792424]"> {{approval.remarks}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
            <button class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md w-[100px]" v-if="Data.con_status == 'A' && activeBtn =='Button1'" @click="$emit('NoteLeave',Data.leave_key)" >Note</button>
            <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px]" @click="$emit('cancel')" >Close</button>
        </div>
    </div>
</div>

</template>

<script>

import { defineComponent } from "vue";
import Services from '../../../services/admin'

export default defineComponent({
components: {
   
},
data() {
    return {
        lvkey:null,
        info:'',
        loading:false,
        signatory: null,
        recommendation:'',
        approval:'',
    }
},
props: {
    Data: {
        type: Object,
        default: null,
    },
    Approval:{
        type : Boolean,
        default: false,
    },
    activeBtn:{
        type: String,
        default: null,
    }
},

mounted() {
   this.lvkey = this.Data
   this.getCoveredDate()
   this.getLeaveSignatory()
},  
methods:{

    async getCoveredDate(){
        this.loading = true
        const success       = await Services.leaveCoveredDate(this.Data.leave_key);
        this.info           = success.data
        
    },
    async getLeaveSignatory(){
        const success           = await Services.leaveSignatory(this.Data.leave_key);
        this.signatory          = success.data
        if(this.signatory!=null ){
            this.recommendation = this.signatory.filter(signatory=>signatory.rank == 'R')
            this.approval       = this.signatory.filter(signatory=>signatory.rank == 'A')
            if(this.approval.length == 0){
                this.approval   = null
            }
        }
        this.loading = false
    }
}
})

</script>

<style scoped>
table tr th{
    padding: 7px 0px;
}
table tr td{
    border-bottom: 1px solid rgb(228, 226, 226);
    padding: 10px 10px ;
    color: rgb(48, 49, 49);
    text-align: center;
}
.loader {
    width: 48px;
    height: 48px;
    border: 5px solid #ffffff;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 


</style>